import * as React from "react";
import { DropdownInput } from "../DropdownInput";
import axios from "axios";
import { stateOptions } from "data";
import { useWatch } from "react-hook-form";

export function GarageState({ control, producers, setValue }) {
  const [allowedStates, setAllowedStates] = React.useState([]);
  const [carriersData, setCarriersData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Watch selected garage state
  const garageState = useWatch({ control, name: "step1.garageState" });

  React.useEffect(() => {
    async function fetchAllowedStates() {
      try {
        const response = await axios.get("/api/quote/allowedStates");
        const apiData = response.data.data || [];

        setCarriersData(apiData);

        // Get producer's states (e.g. ["Texas"])
        const producerStates = producers?.data?.states || [];

        // Convert producer states to codes (["TX"])
        const producerStateCodes = stateOptions
          .filter((opt) => producerStates.includes(opt.value))
          .map((opt) => opt.label);

        // Collect all allowed state codes for the carriers
        const allAllowedStates = new Set(
          apiData.flatMap((carrier) => carrier.AllowedStates)
        );

        // Filter by producer states (still required base constraint)
        const filteredAllowedStates = Array.from(allAllowedStates).filter((code) =>
          producerStateCodes.includes(code)
        );

        // Map back to full state objects
        const finalAllowedStateOptions = stateOptions.filter((opt) =>
          filteredAllowedStates.includes(opt.label)
        );

        setAllowedStates(finalAllowedStateOptions);
      } catch (error) {
        console.error("Failed to fetch allowed states", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllowedStates();
  }, [producers]);

  // 🔹 Whenever garage state changes, recompute allowed carriers
  React.useEffect(() => {
    if (!garageState || !carriersData.length) {
      setValue("step1.allowedCarriers", [], { shouldValidate: false });
      return;
    }

    // Find matching carrier(s)
    const selectedStateCode = stateOptions.find(
      (opt) => opt.value === garageState
    )?.label;

    const allowedCarriers = carriersData
      .filter((carrier) => carrier.AllowedStates.includes(selectedStateCode))
      .map((carrier) => carrier.CarrierName);

    setValue("step1.allowedCarriers", allowedCarriers, {
      shouldDirty: false,
      shouldValidate: true,
    });
  }, [garageState, carriersData, setValue]);

  return (
    <div className="space-y-2">
      <DropdownInput
        control={control}
        label="What is the insured's garage state?"
        dropdownLabel="Select State"
        stepName="step1.garageState"
        stepId="step1"
        itemList={allowedStates}
        loading={loading}
      />
    </div>
  );
}
